// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legend-header[data-v-f1ca343a]{border-bottom:3px solid #c3c0c0;font-size:15px!important;line-height:30px;color:#214282;font-weight:600}.legend-header[data-v-f1ca343a]:hover{background-color:rgba(195,192,192,.4)}.container_legend[data-v-f1ca343a]{padding:2px 0}", ""]);
// Exports
module.exports = exports;
